import React, { Component } from 'react';

import i18n from 'i18n-react';
import { HashLink as Link } from 'react-router-hash-link';

import { name, storageKeys } from 'settings';
import { BackImage, StorageHandler, LanguageSelect } from 'C4';

import logo from 'assets/images/logo/logo.png';


export default class WelcomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstName: '',
      lastName: '',
      agency: '',
      state: '',
    };
  }

  componentDidMount() {
    this.clearCache();
  }

  clearCache() {
    StorageHandler.remove(storageKeys.progress);
    window.location.href('/login');
  }

  render() {
    const {
      agency,
      state,
      firstName,
      lastName,
    } = this.state;

    return (
      <div className="welcomeView">
        <BackImage darken />
        <div className="welcomeView__Wrapper">
          Removing caching and redirecting to login...
        </div>
      </div>
    );
  }
}
